var React = require('react');
var ReactNative = require('react-native');

var AppManager = require('./appManager.js');
var BundleVersion = require('./BundleVersion.js');
var RNReUpUpdater = require('react-native').NativeModules.RNReUpUpdater;

var PlatformConstants = require('./constants/PlatformConstants');

var {
  AppRegistry,
  Text,
  View,
  Image,
  StyleSheet,
} = ReactNative;

function findGetParameter(parameterName) {
    var result = null,
        tmp = [];
    location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
          tmp = item.split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
    return result;
}

var SPLASH_DELAY = (findGetParameter("isPass") != "1" && findGetParameter("isPassFree") != "1") ? 200 : 0;

var Splash = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      splashDidFinish : function(){},
    }
  },

  getInitialState : function()
  {
    return {
      resourcesSynced : false,
      hasCheckedResourcesSynced : false,
    }
  },

  componentDidMount : function()
  {
    var splash = this;

    AppManager.SKIP_TUTORIAL = typeof this.props.SKIP_TUTORIAL !== 'undefined' && this.props.SKIP_TUTORIAL;

    AppManager.doResourcesExist(function(resourceExist)
    {
      splash.setState({resourcesSynced:resourceExist, hasCheckedResourcesSynced:true})
    })

    if( RNReUpUpdater ) RNReUpUpdater.setBundleVersionString(BundleVersion);
    AppManager.initialize(function(data)
    {
      splash.checkUpdate(function()
      {
        setTimeout(function()
        {
          splash.props.splashDidFinish(AppManager);
        },SPLASH_DELAY)
      });
    });
  },

  checkUpdate : function(completion)
  {
    if( completion ) completion();
  },

  render: function()
  {
    if( this.state.hasCheckedResourcesSynced == false ) return <View style={{backgroundColor:'black'}} />;

    var splashImageURI = PlatformConstants.resourcesDirectory + '/App/Splash.png';
    if( !this.state.resourcesSynced )
    {
      splashImageURI = PlatformConstants.packagedResourcesDirectory + '/App/Splash.png';
    }
    if( (findGetParameter("isPass") == "1" || findGetParameter("isPassFree") == "1") )
    {
      splashImageURI = "";
    }

    return (
      <View style={styles.imageContainer}>
        <Image
          style={styles.image}
          resizeMode={"cover"}
          source={{uri: splashImageURI}}
        />
      </View>
    );
  }
});

var styles = StyleSheet.create({
  imageContainer: {
    flex: 1,
    alignItems: 'stretch',
  },
  image: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

module.exports = Splash;
